import './experiment/experimentLoader';
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import MainResults from './components/MainResults.vue'
import SearchForm from './components/SearchForm.vue'
import SearchResults from './components/SearchResults.vue'
import StraightResult from "./components/StraightResult";
import analytics from './tools/ga'
import Vue from 'vue';
import {onLCP, onFID, onCLS, onFCP, onTTFB, onINP} from 'web-vitals';

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('./tools/languageToggler');
require('./tools/faqDropdown');
require('./tools/createArrow');

onCLS(analytics.sendWebVitalsToGA);
onFID(analytics.sendWebVitalsToGA);
onLCP(analytics.sendWebVitalsToGA);
onFCP(analytics.sendWebVitalsToGA);
onTTFB(analytics.sendWebVitalsToGA);
onINP(analytics.sendWebVitalsToGA);

const app = new Vue({
    el: '#main',
    components: {
        SearchResults,
        StraightResult,
        MainResults,
        SearchForm,
    },
    data() {
        return {
            getSignedRequestBody: null,
        }
    },
    created() {
    },
    async beforeMount() {
        await this.initSignedRequest();
    },
    async mounted() {
        this.$on('link-insert', (link) => {
            analytics.linkInsert(link)
        })
        this.$on('link-submit', (link) => {
            analytics.linkSubmit(link)
        })
        this.$on('link-submit-posts', (link) => {
            analytics.linkSubmit(link)
        })
        this.$on('link-submit-stories', (link) => {
            analytics.linkSubmit(link)
        })
        this.$on('link-submit-reels', (link) => {
            analytics.linkSubmit(link)
        })

        this.$on('straight-submit', (link) => {
            analytics.linkSubmit(link)
        })
        this.$on('link-cast', (link) => {
            analytics.linkInsert(link)
        })
        this.$on('profile-request', (query) => {
            if (query !== null) {
                analytics.profileSubmit(query)
            }
        })
        this.$on('search-download', (link) => {
            analytics.searchDownload(link)
        })
        this.$on('download-click', (link, format) => {
            analytics.downloadClick(link, format)
        })
        this.$on('show-results', (result, link) => {
            analytics.showResults(link);
        })
        this.$on('show-error', (e, link) => {
            analytics.showError(e);
        })
        this.$on('send-error-time', (start, link) => {
        })
    },
    methods: {
        async initSignedRequest() {
            try {
                this.getSignedRequestBody = await (
                    await import(
                        /* webpackChunkName: "link.chunk" */
                        './tools/getSignedRequestBody.js'
                        )
                    ).default
            } catch (error) {
                this.getSignedRequestBody = async (requestData) => {
                    return typeof requestData === 'string' ? { sf_url: requestData } : requestData;
                }
            }
        },
        async subscribeSignedRequestBody(url) {
            try {
                return await this.getSignedRequestBody(
                    url
                );
            } catch (error) {
                // фикс когда нажимаем на кнопку скачать и нас перекидывает на нову страницу с заранее введенной ссылкой
                // выкидывало ошибку что getSignedRequestBody is not a function
                await this.initSignedRequest();

                return await this.getSignedRequestBody(
                    url
                );
            }
        },
    },
})

